import React, {useEffect, useRef} from 'react';
import {IconButton, Select, Portal, useSelectContext} from "@chakra-ui/react";

const SelectTrigger = ({icon}) => {
    const select = useSelectContext()
    return (
        <IconButton
            px="2"
            variant="outline"
            h={"100%"}
            {...select.getTriggerProps()}
            border={"0px"}
            _hover={{ bg: "transparent" }}
        >
            {icon}
        </IconButton>
    )
}

export const IconSelect = ({children, icon, collection, value, onValueChange, ...props}) => {

    const selectRef = useRef(null);

    return <Select.Root
        ref={selectRef}
        positioning={{sameWidth: false}}
        collection={collection}
        value={value}
        onValueChange={(e) => onValueChange(e)}
        {...props}
    >
        <Select.HiddenSelect
        />
        <Select.Control
            background={'secondary'}
            h={"100%"}
            borderRadius="sm"
        >
            <SelectTrigger
                icon={icon}
            />
        </Select.Control>
        <Portal>
            <Select.Positioner
            >
                <Select.Content>
                    {children}
                </Select.Content>
            </Select.Positioner>
        </Portal>
    </Select.Root>;
};

export default IconSelect;
